import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import { purchaseOrdersIndex, downloadOrderPdf } from '../../redux/actions/purchaseOrders';
import { suppliersIndex } from '../../redux/actions/suppliers';

const ArchivedIndex = ({ payload, loadPurchaseOrders, loadSuppliers, purchaseOrders, suppliers, download, downloadUrl }) => {
  const [downloadSubmitted, setDownloadSubmitted] = useState(false);

  const [page, setPage] = useState(0);

  useEffect(() => {
    loadNextPurchaseOrders();
    loadSuppliers(payload);
  }, []);

  useEffect(() => {
    if(downloadUrl && downloadSubmitted) { 
      setDownloadSubmitted(false); 
      let win = window.open(downloadUrl, '_blank');
      win.focus();
    }
  }, [downloadUrl]);

  const loadPreviousPurchaseOrders = () => {
    let previousContinuationToken = purchaseOrders.purchaseOrdersSearchStack[page - 2];
    loadPurchaseOrders(payload, previousContinuationToken, (page - 1));

    setPage(page - 1);
  }

  const loadNextPurchaseOrders = () => {
    loadPurchaseOrders(payload, purchaseOrders.purchaseOrdersSearchStack[page], (page + 1));
    setPage(page + 1);
  }

  const downloadPdf = (purchaseOrderId) => {
    setDownloadSubmitted(true);

    let options = {
      poNum: true,
      invoiceNum: true,
      deliveryDate: true,
      paymentExpectedDate: true,
      adjustedPrice: true,
      estimatedShippingPrice: true,
      taxColumn: true
    }

    download(payload, purchaseOrderId, options);
  }

  const supplierData = (supplierId) => {
    let supplier = suppliers.suppliers.find(supplier => supplier.id === supplierId);

    if(supplier) {
      return (
        <>
          <strong>Supplier</strong>: { supplier.supplier_name }
          <br/>
          { supplier.account_number &&
            <>
              <strong>Account Number</strong>: { supplier.account_number }
              <br/>
            </>
          }
          { supplier.contact_email &&
            <>
              <strong>Contact Email</strong>: { supplier.contact_email }
              <br/>
            </>
          }
          { supplier.contact_phone &&
            <>
              <strong>Contact Phone</strong>: { supplier.contact_phone }
              <br/>
            </>
          }
        </>
      )
    }

    return(
      <>
        <p><strong>Supplier</strong>: Supplier no longer exists</p>
      </>
    )
  }

  return(
    <>
      <PageHeader stripeBackground='#fbe194' helpLink="ecwid/manage-purchase-orders-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Archived Purchase Orders</div>
              </div>
              <div className="named-area__description">
                <p>From this page, you can view archived purchase orders. These are purchase orders that have been fulfilled and archived.</p>
                <p>This data is stored for 30 days before being deleted.</p>
              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">
                
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <div className="flex-container">
                      <div className="flex-1">
                        <button
                          className="btn btn-default"
                          onClick={() => loadPreviousPurchaseOrders()}
                          disabled={page === 1}
                        >
                          <span className="svg-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.284 9.9992H15c.5523 0 1-.4477 1-1 0-.5522-.4477-1-1-1H5.284l2.7725-3.0035c.3746-.4059.3493-1.0385-.0565-1.4131-.4058-.3746-1.0385-.3493-1.413.0565L2.2651 8.321a1 1 0 0 0 0 1.3565l4.3217 4.6819c.3746.4058 1.0073.4311 1.4131.0565.4058-.3746.4311-1.0072.0565-1.4131L5.284 9.9992z"/></svg>
                          </span>
                          <span className="gwt-InlineLabel">Previous Purchase Orders</span>
                        </button>

                        <button
                          className="btn btn-default"
                          onClick={() => loadNextPurchaseOrders()}
                          disabled={purchaseOrders.lastPage}
                        >
                          <span className="gwt-InlineLabel">Next Purchase Orders</span>
                          <span className="svg-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.716 9.9992H3c-.5523 0-1-.4477-1-1 0-.5522.4477-1 1-1h9.716L9.9435 4.9958c-.3746-.4059-.3493-1.0385.0565-1.4131.4058-.3746 1.0385-.3493 1.4131.0565l4.3217 4.6819a1 1 0 0 1 0 1.3565l-4.3217 4.6819c-.3746.4058-1.0073.4311-1.4131.0565-.4058-.3746-.4311-1.0072-.0565-1.4131l2.7725-3.0036z"/></svg>
                          </span>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>





                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { purchaseOrders.isFetching &&
                      <LoadingSpinner statusText="Loading Purchase Orders" />
                    }

                    { purchaseOrders.purchaseOrders.length === 0 && !purchaseOrders.isFetching &&
                      <div>
                        <div className="text-center">
                          <p>No archived purchase orders. When you have archived purchase orders, you'll see them in a list here.</p>
                        </div>
                      </div>
                    }

                    { purchaseOrders.purchaseOrders.map(purchaseOrder =>
                      <>
                        <h4>
                          {purchaseOrder.invoice_number || purchaseOrder.id}
                          <span className="left-15">
                            <Link to={`/purchase_order/copy/${purchaseOrder.id}?status=archived`}>
                              <button className="btn btn-default">
                                <span className="svg-icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5 4V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1.0001 1.0001 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H2.007a1.0007 1.0007 0 0 1-.93-.6159A1.0007 1.0007 0 0 1 1 17l.003-12c0-.552.45-1 1.007-1H5zM3.003 6 3 16h8V6H3.003zM7 4h5c.5523 0 1 .4477 1 1v7h2V2H7v2z"/></svg>
                                </span>
                                <span className="gwt-InlineLabel">Copy</span>
                              </button>
                            </Link>
                          </span>
                        </h4>
                        
                        <div className="flex-container space-between">
                          <div className="flex1 left-15">
                            { purchaseOrder.supplier_order_number &&
                              <>
                                <strong>Purchase Order Number</strong>: { purchaseOrder.supplier_order_number }
                                <br/>
                              </>
                            }
                            { purchaseOrder.supplier_id && suppliers.status === 'success' &&
                              <>
                                {supplierData(purchaseOrder.supplier_id)}
                              </>
                            }
                            { purchaseOrder.supplier_id && suppliers.isFetching &&
                              <LoadingSpinner size="xxSmall" statusText="Loading Suppliers" />
                            }

                          </div>

                          <div className="flex1 left-15">
                            <strong>PO Status</strong>: { purchaseOrder.status }<br/>
                            <strong>Type</strong>: { purchaseOrder.ship_to_type }<br/>
                            <strong>Shipment Expected</strong>: { (new Date(purchaseOrder.shipment_expected_at)).toISOString().split('T')[0] }
                          </div>

                          <div className="flex1 left-15">
                            <strong>Payment status</strong>: { purchaseOrder.payment_status }
                            <br/>
                            <strong>Payment due</strong>: { (new Date(purchaseOrder.payment_due_at)).toISOString().split('T')[0] }
                          </div>
                          
                          <div className="flex1 left-15 flex-container flex-column">
                            <button
                              className="btn btn-default"
                              onClick={() => downloadPdf(purchaseOrder.id)}
                              disabled={downloadSubmitted}
                              isLoading={downloadSubmitted}
                            >
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M2 16c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 1c.5523 0 1 .4477 1 1v7.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0L8 9.5858V2c0-.5523.4477-1 1-1z"/></svg>
                              </span>
                              <span className="gwt-InlineLabel">Download PDF</span>
                            </button>
                            <br/>
                          </div>
                        </div>
                        <hr/>
                      </>
                    )}

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

const mapStateToProps = state => ({
  purchaseOrders: state.purchaseOrders,
  suppliers: state.suppliers,
  downloadUrl: state.purchaseOrders.downloadUrl,
});

const mapDispatchToProps = (dispatch) => ({
  loadPurchaseOrders: (payload, continuationToken, page) => dispatch(purchaseOrdersIndex(payload, 'archived', continuationToken, page)),
  loadSuppliers: (payload) => dispatch(suppliersIndex(payload)),
  download: (payload, purchaseOrderId, options) => dispatch(downloadOrderPdf(payload, 'archived', purchaseOrderId, options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArchivedIndex);